




















import Vue from 'vue';
// import { firebase } from 'mostra';
// import buyer, { Buyer } from '@/modules/buyer/buyer';
// import company, { Company } from '@/modules/buyer/company';
import {
  buyer,
  Buyer,
  buyerCompany as company,
  BuyerCompany as Company,
  createNewBuyer,
  createNewBuyerCompany,
  firebase,
} from 'mostra';

import { v4 } from 'uuid';

interface DataType {
  buyer: Buyer | null;
  company: Company | null;
  account: {
    email: string;
    password: string;
  };
  loading: boolean;
}

export default Vue.extend({
  name: 'admin-buyer-new',
  data(): DataType {
    return {
      buyer: null,
      company: null,
      loading: true,
      account: {
        email: '',
        password: '',
      },
    };
  },
  methods: {
    async submit() {
      console.log('OK');
    },
    async onClick() {
      try {
        this.$loading(true);
        // this.loading = true;
        if (this.buyer && this.company) {
          const ret = await firebase.functions('createBuyer', {
            email: this.account.email,
            password: this.account.password,
          });

          // const uid = this.$auth.uid;
          const auth = ret.data;
          const uid = auth.uid;
          const cid = v4();

          const now = firebase.now();
          this.company.id = cid;
          this.company.data.owner = uid;
          this.company.data.members.push(uid);
          this.company.data.registeredDate = now;
          this.company.data.createdDt = now;
          this.company.data.createdBy = this.$auth.uid;
          this.company = await company.save(this.$auth.uid, this.company);

          this.buyer.id = uid;
          this.buyer.data.cid = cid;
          this.buyer.data.email = this.account.email;
          this.buyer.data.registeredDate = now;
          this.buyer.data.createdDt = now;
          this.buyer.data.createdBy = this.$auth.uid;
          this.buyer = await buyer.save(this.$auth.uid, this.buyer);
          this.$success('保存しました。');
        }
      } catch (error: any) {
        this.$error('保存に失敗しました。', error);
      } finally {
        this.$loading(false);
      }
    },
    async fetchData() {
      try {
        const uid = this.$auth.uid;
        // TODO: ここでbuyerとcompanyがnullだとadmin画面からのbuyer登録不可
        if (uid === 'new') {
          this.loading = true;
          // const cid = v4();
          this.buyer = createNewBuyer();
          this.company = createNewBuyerCompany();
        }
      } catch (error: any) {
        this.$fatal(error);
      } finally {
        this.loading = false;
      }
    },
  },
  async beforeRouteUpdate(to, from, next) {
    next();
    await this.fetchData();
  },
  async mounted() {
    // this.updateHeader(this.$route.fullPath);
    await this.fetchData();
  },

});
